const s = {
  name: "HumanResourcesTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6.5,7.5C6.5,5.6,8.1,4,10,4s3.5,1.6,3.5,3.5S11.9,11,10,11S6.5,9.4,6.5,7.5z M10,6C9.2,6,8.5,6.7,8.5,7.5
			S9.2,9,10,9c0.8,0,1.5-0.7,1.5-1.5S10.8,6,10,6z"/>
		<path class="st0" d="M10,0C4.5,0,0,4.5,0,10c0,5.5,4.5,10,10,10c2.4,0,4.6-0.8,6.3-2.3l5.7,5.7l1.4-1.4l-5.7-5.7
			c1.4-1.7,2.3-3.9,2.3-6.3C20,4.5,15.5,0,10,0z M2,10c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8c0,2-0.8,3.9-2,5.3V15c0-1.7-1.3-3-3-3H7
			c-1.7,0-3,1.3-3,3v0.3C2.8,13.9,2,12,2,10z M6,16.9V15c0-0.5,0.5-1,1-1h6c0.5,0,1,0.5,1,1v1.9c-1.2,0.7-2.5,1.1-4,1.1
			C8.5,18,7.2,17.6,6,16.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as HumanResourcesTeam
};
